"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ComparisonExprNode = void 0;
const sheet_db_1 = require("../../sheet_db");
const base_1 = require("./base");
const column_node_1 = require("./column.node");
const foreign_node_1 = require("./foreign.node");
class ComparisonExprNode extends base_1.InternalNode {
    constructor(originalNode, astParent) {
        super(originalNode, astParent);
        this._startPosition = originalNode.start.start;
        this._endPosition = originalNode.stop?.stop ?? originalNode.start.stop;
        this._treeNodeType = base_1.TreeNodeType.COMPARISON_NODE;
    }
    accept(v) {
        if (v.visitComparisonExpr)
            v.visitComparisonExpr(this);
        this.visitChildren(v);
    }
    getComparisonType() {
        const isRange = (node) => node instanceof foreign_node_1.ForeignNode;
        const isColumn = (node) => node instanceof column_node_1.ColumnNode;
        const [left, _, right] = this.children;
        if (!isRange(left) && !isRange(right))
            return sheet_db_1.FormulaComparisonType.REGULAR;
        if (isColumn(left) || isColumn(right))
            return sheet_db_1.FormulaComparisonType.RANGE_AND_COLUMN;
        if (isRange(left) && isRange(right))
            return sheet_db_1.FormulaComparisonType.RANGE_AND_RANGE;
        return sheet_db_1.FormulaComparisonType.RANGE_AND_CONSTANT;
    }
    getReturnType() {
        return sheet_db_1.ColumnType.BOOLEAN;
    }
}
exports.ComparisonExprNode = ComparisonExprNode;
